"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CounterFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [],
        name: "count",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "count2",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "decrement",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "doRevert",
        outputs: [],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "increment",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount2",
                type: "uint256",
            },
        ],
        name: "increment",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "notZero",
        outputs: [],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610272806100206000396000f3fe6080604052600436106100605760003560e01c806306661abd1461006557806319a50d4a1461008c5780631d63e24d146100a35780633a9ebefd146100b85780637cf5dab0146100d5578063924ba506146100f2578063afc874d214610115575b600080fd5b34801561007157600080fd5b5061007a61012a565b60408051918252519081900360200190f35b34801561009857600080fd5b506100a1610130565b005b3480156100af57600080fd5b5061007a610179565b6100a1600480360360208110156100ce57600080fd5b503561017f565b6100a1600480360360208110156100eb57600080fd5b50356101d6565b6100a16004803603604081101561010857600080fd5b50803590602001356101e1565b34801561012157600080fd5b506100a16101f6565b60005481565b600054610177576040805162461bcd60e51b815260206004820152601060248201526f436f756e7465723a3a6e6f745a65726f60801b604482015290519081900360640190fd5b565b60015481565b6000548111156101ca576040805162461bcd60e51b8152602060048201526011602482015270636f756e74657220756e646572666c6f7760781b604482015290519081900360640190fd5b60008054919091039055565b600080549091019055565b60008054909201909155600180549091019055565b6040805162461bcd60e51b8152602060048201526017602482015276436f756e7465723a3a7265766572742054657374696e6760481b604482015290519081900360640190fdfea265627a7a723158209285c793020c136aa664e2f94c8324ad3e0163e066cba3a2ec660ef978ee418464736f6c63430005100032";
class CounterFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.CounterFactory = CounterFactory;
CounterFactory.bytecode = _bytecode;
CounterFactory.abi = _abi;
//# sourceMappingURL=CounterFactory.js.map